(function($, undefined) {
	
	'use strict';
	var blogIds;
	var formValidator;

	var getBlogs = function(blogIds) {
		var ctn = blogIds.closest('.related-blogs-js');
		var months = ctn.attr('data-months').split(',');
		var clone = ctn.find('.js-blog-link-ctn.clone');
		var ids = blogIds.val().trim().split(' ').join().replace(/,,/g, ',');

		ajax('/action/ajaxGetBlog?ajax=true&ids='+ids, function(response){
			var json = JSON.parse(response.trim());
			
			$.each(json, function(k, v) {
				var blogClone = clone.clone();
				var link = blogClone.find('.js-blog-link');
				var img = blogClone.find('.js-blog-img');

				if (json[k].imagePath) {
                    img.css('background-image', json[k].imagePath);
                } else if (json[k].mediaId !== '0') {
					img.css('background-image', img.attr('data-prefix') + json[k].mediaId + img.attr('data-suffix'));
				} else {
					img.remove();
				}

				var url = link.attr('href') + json[k].friendlyUrl;
				link.attr('href', url);
				blogClone.find('.js-blog-date').html(json[k].postTimeDay + ' ' + months[json[k].postTimeMonth] + ' ' + json[k].postTimeYear);
				blogClone.find('.js-blog-name').html(hexToHtml(json[k].title));

				blogClone.removeClass('clone');
				ctn.append(blogClone);
			});

			ctn.closest('.page-split-right-side-infos-ctn').slideDown();

		},true);
	};
    
    function decodeText() {
        var txt = name;
		txt = txt
            .replace(/\\\\xA9/g, '\xA9')
            .replace(/\\\\xAE/g, '\xAE')
            .replace(/\\\\xE0/g, '\xE0')
		    .replace(/\\\\xE1/g, '\xE1')
		    .replace(/\\\\xE2/g, '\xE2')
		    .replace(/\\\\xE3/g, '\xE3')
		    .replace(/\\\\xE4/g, '\xE4')
		    .replace(/\\\\xE5/g, '\xE5')
		    .replace(/\\\\xE6/g, '\xE6')
		    .replace(/\\\\xE7/g, '\xE7')
		    .replace(/\\\\xE8/g, '\xE8')
		    .replace(/\\\\xE9/g, '\xE9')
		    .replace(/\\\\xEA/g, '\xEA')
		    .replace(/\\\\xEB/g, '\xEB')
		    .replace(/\\\\xEC/g, '\xEC')
		    .replace(/\\\\xED/g, '\xED')
		    .replace(/\\\\xEE/g, '\xEE')
		    .replace(/\\\\xEF/g, '\xEF')
		    .replace(/\\\\xF1/g, '\xF1')
		    .replace(/\\\\xF2/g, '\xF2')
		    .replace(/\\\\xF3/g, '\xF3')
		    .replace(/\\\\xF4/g, '\xF4')
		    .replace(/\\\\xF6/g, '\xF6')
		    .replace(/\\\\xF9/g, '\xF9')
		    .replace(/\\\\xFA/g, '\xFA')
		    .replace(/\\\\xFB/g, '\xFB')
		    .replace(/\\\\xFC/g, '\xFC')
		    .replace(/\\\\xFD/g, '\xFD')
		    .replace(/\\\\xFF/g, '\xFF')
		    .replace(/\\\\xC0/g, '\xC0')
		    .replace(/\\\\xC1/g, '\xC1')
		    .replace(/\\\\xC2/g, '\xC2')
		    .replace(/\\\\xC3/g, '\xC3')
		    .replace(/\\\\xC4/g, '\xC4')
		    .replace(/\\\\xC5/g, '\xC5')
		    .replace(/\\\\xC6/g, '\xC6')
		    .replace(/\\\\xC7/g, '\xC7')
		    .replace(/\\\\xC8/g, '\xC8')
		    .replace(/\\\\xC9/g, '\xC9')
		    .replace(/\\\\xCA/g, '\xCA')
		    .replace(/\\\\xCB/g, '\xCB')
		    .replace(/\\\\xCC/g, '\xCC')
		    .replace(/\\\\xCD/g, '\xCD')
		    .replace(/\\\\xCE/g, '\xCE')
		    .replace(/\\\\xCF/g, '\xCF')
		    .replace(/\\\\xD1/g, '\xD1')
		    .replace(/\\\\xD2/g, '\xD2')
		    .replace(/\\\\xD3/g, '\xD3')
		    .replace(/\\\\xD4/g, '\xD4')
		    .replace(/\\\\xD5/g, '\xD5')
		    .replace(/\\\\xD6/g, '\xD6')
		    .replace(/\\\\xD9/g, '\xD9')
		    .replace(/\\\\xDA/g, '\xDA')
		    .replace(/\\\\xDB/g, '\xDB')
		    .replace(/\\\\xDC/g, '\xDC')
		    .replace(/\\\\xDD/g, '\xDD')
		    .replace(/\\\\xDF/g, '\xDF');
		return decodeURI(txt);
    }

	function hexToHtml(name) {
        var txt = name;
		txt = txt
            .replace(/\\xA9/g, '&#169;')
            .replace(/\\xAE/g, '&#174;')
            .replace(/\\xE0/g, '&#224;')
		    .replace(/\\xE1/g, '&#225;')
		    .replace(/\\xE2/g, '&#226;')
		    .replace(/\\xE3/g, '&#227;')
		    .replace(/\\xE4/g, '&#228;')
		    .replace(/\\xE5/g, '&#229;')
		    .replace(/\\xE6/g, '&#230;')
		    .replace(/\\xE7/g, '&#231;')
		    .replace(/\\xE8/g, '&#232;')
		    .replace(/\\xE9/g, '&#233;')
		    .replace(/\\xEA/g, '&#234;')
		    .replace(/\\xEB/g, '&#235;')
		    .replace(/\\xEC/g, '&#236;')
		    .replace(/\\xED/g, '&#237;')
		    .replace(/\\xEE/g, '&#238;')
		    .replace(/\\xEF/g, '&#239;')
		    .replace(/\\xF1/g, '&#241;')
		    .replace(/\\xF2/g, '&#242;')
		    .replace(/\\xF3/g, '&#243;')
		    .replace(/\\xF4/g, '&#244;')
		    .replace(/\\xF6/g, '&#245;')
		    .replace(/\\xF9/g, '&#249;')
		    .replace(/\\xFA/g, '&#250;')
		    .replace(/\\xFB/g, '&#251;')
		    .replace(/\\xFC/g, '&#252;')
		    .replace(/\\xFD/g, '&#253;')
		    .replace(/\\xFF/g, '&#255;')
		    .replace(/\\xC0/g, '&#192;')
		    .replace(/\\xC1/g, '&#193;')
		    .replace(/\\xC2/g, '&#194;')
		    .replace(/\\xC3/g, '&#195;')
		    .replace(/\\xC4/g, '&#196;')
		    .replace(/\\xC5/g, '&#197;')
		    .replace(/\\xC6/g, '&#198;')
		    .replace(/\\xC7/g, '&#199;')
		    .replace(/\\xC8/g, '&#200;')
		    .replace(/\\xC9/g, '&#201;')
		    .replace(/\\xCA/g, '&#202;')
		    .replace(/\\xCB/g, '&#203;')
		    .replace(/\\xCC/g, '&#204;')
		    .replace(/\\xCD/g, '&#205;')
		    .replace(/\\xCE/g, '&#206;')
		    .replace(/\\xCF/g, '&#207;')
		    .replace(/\\xD1/g, '&#209;')
		    .replace(/\\xD2/g, '&#210;')
		    .replace(/\\xD3/g, '&#211;')
		    .replace(/\\xD4/g, '&#212;')
		    .replace(/\\xD5/g, '&#213;')
		    .replace(/\\xD6/g, '&#214;')
		    .replace(/\\xD9/g, '&#217;')
		    .replace(/\\xDA/g, '&#218;')
		    .replace(/\\xDB/g, '&#219;')
		    .replace(/\\xDC/g, '&#220;')
		    .replace(/\\xDD/g, '&#221;')
		    .replace(/\\xDF/g, '&#223;');
		return txt;
	}

	var init = function () {
		blogIds = $('.related-blogs-ids');

		if (blogIds.length) {
			blogIds.each(function() {
				if ($(this).val() !== '') {
					getBlogs($(this));
				}
			});
		}

		// $('.comment-input').on('input', function(e) {
		// 	var hasText = $(this).val().trim().length > 0;
		// 	var hasAuthor = $('.comment-author').val().trim().length > 0;

		// 	$('.submit-comment-form').prop('disabled', (!hasText || !hasAuthor));
		  
		//   });

		$('.comment-input, .comment-author').on('input', function() {
			var $form = $(this).closest('.blog-comment-form');
			var hasText = $form.find('.comment-input').val().trim().length > 0;
			var hasAuthor = $form.find('.comment-author').val().trim().length > 0;
			
			$form.find('.submit-comment-form').prop('disabled', !(hasText && hasAuthor));
			});
		

		$('.blog-comment-reply').on('click', function() {
			$(this).next('.replies').slideToggle(); // Toggles the visibility with animation
		});
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
